import * as React from "react";
import { FormattedHTMLMessage } from "react-intl";

const UserTerms: React.FC<{}> = () => {
  return <FormattedHTMLMessage id="user.terms" />;
};

export default UserTerms;
